export default __webpack_public_path__ + "static/media/cloud-9.2f16299e.png";